import React, { useState, useEffect } from 'react'
import { CCard, CCardBody, CCol, CRow } from 'compat/coreui'
import axios from 'axios';
import moment from 'moment';

const Stars = ({ value }) => (
    <span className="bp-stars-row">
        {[1, 2, 3, 4, 5].map(n => <span key={n} className={n <= value ? 'on' : ''}>★</span>)}
    </span>
);

export default function Reviews() {
    const [reviews, setReviews] = useState([]);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_APP_API_URL}/api/review`, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        }).then(response => {
            if (response.data.status) setReviews(response.data.review || []);
        }).catch(() => {})
    }, []);

    const avg = reviews.length
        ? (reviews.reduce((s, r) => s + (r.rating || 0), 0) / reviews.length).toFixed(1)
        : null;

    return (
        <>
            <CRow className="mb-3">
                <CCol>
                    <h2 style={{ fontWeight: 800, marginBottom: 4 }}>Reviews</h2>
                    <p className="text-muted">
                        {avg
                            ? <>Your shop averages <strong>{avg} ★</strong> across {reviews.length} review{reviews.length === 1 ? '' : 's'}.</>
                            : 'What shoppers say about your shop shows up here.'}
                    </p>
                </CCol>
            </CRow>
            {reviews.length === 0 ? (
                <CCard>
                    <CCardBody className="text-center" style={{ padding: '54px 20px' }}>
                        <span style={{ fontSize: 40 }} aria-hidden="true">⭐</span>
                        <h4 style={{ fontWeight: 800, margin: '12px 0 6px' }}>No reviews yet</h4>
                        <p className="text-muted" style={{ maxWidth: 420, margin: '0 auto' }}>
                            Reviews appear after shoppers visit your page — great service and fast shipping earn them.
                        </p>
                    </CCardBody>
                </CCard>
            ) : (
                <CCard>
                    <CCardBody>
                        <div className="bp-review-list" style={{ marginTop: 0 }}>
                            {reviews.map((r, i) => (
                                <div className="bp-review-item" key={r._id || i}>
                                    <div className="bp-review-item-head">
                                        <Stars value={r.rating || 0} />
                                        <span className="text-muted">{r.createdAt ? moment(r.createdAt).format('MMM D, YYYY') : ''}</span>
                                    </div>
                                    <p>{r.msg}</p>
                                </div>
                            ))}
                        </div>
                    </CCardBody>
                </CCard>
            )}
        </>
    )
}
